export default {
  "content": "<path d=\"M5 19h4v2H4a1 1 0 01-1-1v-5h2v4zM21 20a1 1 0 01-1 1h-5v-2h4v-4h2v5zM9 5H5v4H3V4a1 1 0 011-1h5v2zM20 3a1 1 0 011 1v5h-2V5h-4V3h5z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};